import { BITF_CONFIGS as COMMON_BITF_CONFIGS } from '@common/configs/common-bitf.configs';

const WEB_BITF_CONFIGS = {
  urls: { homePageUrl: '/', signInUrl: '/sign-in', signOutUrl: '/sign-in' },
  loaderService: {},
  serviceWorker: { checkUpdateInterval: 30000 },
}; // getAuthTokenComponent: { signInComponent: LoginLoaderComponent },

export const BITF_CONFIGS = Object.assign(COMMON_BITF_CONFIGS, WEB_BITF_CONFIGS);
